<template>
  <div class="result">
    <div class="result-content">
      <img src="/img/online-training/completed.svg" alt="ahamove-driver-training" />
      <h2>
        <b>{{ $t("ONLINE_TRAINING.RESULT.NOTE") }}</b>
      </h2>
      <div class="total_score">
        <p>
          <span class="green" v-if="score !== 0">{{ score }}</span>
          <span v-else class="red">{{ this.scoreDefault }}</span> /
          <span v-if="quizzes">{{ quizzes.questions.length }}</span>
        </p>
        <p class="green">{{ $t("ONLINE_TRAINING.QUIZ.NOTE") }}</p>
        <a :href="supplierProfile.verified ? '/courses-v1' : '/training-v1' " class="back">Trở lại</a>
        <!-- <a href="/courses" class="back">Trở lại</a> -->

      </div>
    </div>
  </div>
</template>
<script>
// mapGetters,
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      scoreDefault: 0,
      timeleft: 5,
    };
  },
  computed: {
    ...mapGetters(['supplierProfile']),
    ...mapState({
      score: state => state.course.score,
      quizzes: state => state.course.quizzes,
      answers: state => state.course.data_answer
    })
  },

  beforeDestroy() {
    this.$store.dispatch("resetData");
  }
};
</script>
<style lang="scss" scoped>
.result {
  position: relative;
  height: 100vh;
  font-weight: 500;
  background: white;
  .green {
    color: #1dc05e !important;
    margin-bottom: 20px;
  }
  .red {
    color: red !important;
  }

  .result-content {
    width: 100%;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    h2 {
      color: #1a1a1a;
      margin: 10px 0;
    }

    .total_score {
      span {
        color: #7a8189;
      }
      span.green {
        font-size: 24px;
      }
      .back {
        color: #ff8200;
      }
    }
    .result-message {
      font-size: 13px;
      color: #bcbcbc;
    }
  }
}
// @media screen and (max-width: 1024px) {
//   .result-content {
//     .total_score {
//       .back{
//         display: none;
//       }
//     }
//   }
// }
</style>
